import { Select } from "collections";
import { ToggleSwitchInput } from "elements";
import React from "react";
import { useTranslation } from "utilities/i18n";

// THE CODE BELOW HAS BEEN HARD CODED DUE TO THE BACKEND NOT BEING READY YET.
// IT WILL BE FEATURE FLAGGED AND NOT HAVE ANY IMPACT ON PRODUCTION

export const AppSoftwareUpdateSettings: React.FC<{ id: string }> = ({ id }) => {
  const { t } = useTranslation();

  return (
    <div className="settings">
      <div className="card title-card">{t("SOFTWARE_UPDATE")}</div>
      <div className="update-buttons" data-testid="sw-update-buttons">
        <button
          type="button"
          className="btn btn-link"
          onClick={() => {}}
          data-testid="check-update-button"
          disabled={false}
        >
          Check for Update
        </button>
        <button
          type="button"
          className="btn btn-primary"
          data-testid="update-button"
          disabled={false}
          onClick={() => {}}
        >
          Update
        </button>
      </div>
      <div className="details grid form update">
        <div className="form-group">
          <div className="col-4 text-right">
            <label>Enable User-Controlled Updates: </label>
          </div>
          <div className="col-4">
            <ToggleSwitchInput
              name="network-testing"
              checked={false}
              onChange={() => {}}
            />
          </div>
        </div>

        <div className="form-group">
          <div className="col-4 text-right">
            <label>Current Poly Lens Desktop Version: </label>
          </div>
          <div className="col-4">
            1.0.2
            <span className="ml-1 available-update">Version Found: 1.0.3</span>
          </div>
        </div>

        <div className="form-group">
          <div className="col-4 text-right">
            <label>Update Deployment Method: </label>
          </div>
          <div className="col-4">
            <Select
              placeholder="Automatic"
              name="deployment-method"
              options={[
                {
                  value: "automatic",
                  text: "Automatic"
                },
                {
                  value: "manual",
                  text: "Manual"
                }
              ]}
              disabled={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
